import api from './api';

export interface ListReportsParams {
  status?: 'unread' | 'all';
  page?: number;
  limit?: number;
}

/**
 * List reports for the staff inbox
 */
export const getReports = async (params: ListReportsParams = {}) => {
  const response = await api.get('/reports', { params });
  return response;
};

/**
 * Get count of unread reports
 */
export const getUnreadCount = async () => {
  const response = await api.get('/reports/unread-count');
  return response;
};

/**
 * Mark a report as read
 */
export const markRead = async (id: number) => {
  const response = await api.patch(`/reports/${id}/read`);
  return response;
};

/**
 * Mark a report as unread
 */
export const markUnread = async (id: number) => {
  const response = await api.patch(`/reports/${id}/unread`);
  return response;
};

/**
 * Soft-delete a report
 */
export const deleteReport = async (id: number) => {
  const response = await api.delete(`/reports/${id}`);
  return response;
};
